/** Labs: what has no real data behind it yet. Reached from the palette only, never from the nav. */

export interface LabsEntry {
  id: string;
  name: string;
  /** One plain line: it is not live. */
  line: string;
  /** Where its job is done now, when that is not a button. */
  hint?: string;
  /** Where that job is done now, as a button. */
  go?: { label: string; to: string };
}

export const LABS: readonly LabsEntry[] = [
  { id: "community", name: "Community", line: "Community is not live yet." },
  { id: "forms", name: "Forms", line: "Forms are not live yet." },
  { id: "fundraising", name: "Fundraising", line: "Fundraising is not live yet." },
  { id: "governance", name: "Governance", line: "Governance is not live yet." },
  { id: "notifications", name: "Notifications", line: "Notifications are not live yet.", hint: "What needs you is on Today." },
  { id: "orgs", name: "Organizations", line: "Organizations are not live yet." },
  { id: "partnerships", name: "Partnerships", line: "Partnerships are not live yet." },
  { id: "store", name: "Store", line: "The store is not live yet.", hint: "Dues and revenue are under Money.", go: { label: "Open Money", to: "/money" } },
];

export function labsEntry(id: string | undefined): LabsEntry | undefined {
  return LABS.find((entry) => entry.id === id);
}
